export enum AssetTelemetryStatus {
    Online = 1,
    Offline = 2,
}
